import * as React from 'react';
import Ranges from '../../../system/ranges';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ColorPicker from './ColorPicker';
import Row from 'react-bootstrap/Row';
import {Action} from '../../../system/buttons';

export class FitnessZoneEdit extends React.Component {
  constructor(props, context) {
    super(props, context);
    if (props.configuration && props.configuration.ranges) {
      this.state = {
        ...props.configuration,
      };
    } else {
      this.state = {
        ranges: [],
      };
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        ranges: this.state.ranges,
      });
    }
  }

  render() {
    return (
      <>
        <h4>Configured ranges</h4>
        <Ranges
          ranges={this.state.ranges}
          onRangesChange={(ranges) => this.setState({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
            color: '#ff5373',
          }}
          header={
            <Col md={3}>
              <Form inline>
                <Col>Color</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <Col md={3} key={range.from}>
              <Form inline>
                <ColorPicker
                  color={range.color}
                  onChangeComplete={(color) =>
                    onRangeChange({
                      ...range,
                      color,
                    })
                  }
                />
              </Form>
            </Col>
          )}
        />
        <Row>&nbsp;</Row>

        <Action
          onClick={() =>
            this.props.onSave({
              ranges: this.state.ranges,
            })
          }
        >
          Save settings
        </Action>
      </>
    );
  }
}
